import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { MatSnackBar } from '@angular/material';
import {AdoptionService} from '../../services/adoption.service';
import {ActivatedRoute, Router, Params } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';
import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl,
   FormControl } from '@angular/forms';
@Component({
  selector: 'app-adoptionrequest',
  templateUrl: './adoptionrequest.component.html',
  styleUrls: ['./adoptionrequest.component.css']
})
export class AdoptionrequestComponent implements OnInit {
  adoprequestflag = 2;
  puserflag = 2;
  state: any;
  city: any;
  userid: any;
  loading = false;
  msg: any;
  action: any;
  post_id: any;
  timer: any;
  counter = 5;
  q9: any;
  q11: any;
  formstatus = 0;
  lastadoptionformid: any;
  lastadoptionform: any;
  adoptionform: any;
  constructor(private adoptionService: AdoptionService, private route: ActivatedRoute,
     private commonService: CommonService, public form: FormBuilder,
     private router: Router, private snackbar: MatSnackBar, private location: Location) {
      window.scrollTo(0, 0);
      this.adoptionform = this.form.group({
        'uname': new FormControl('', [Validators.required]),
        'umobile': new FormControl('', [Validators.required]),
        'uemail': new FormControl('', [Validators.required]),
        'state': new FormControl('', [Validators.required]),
        'city': new FormControl('', [Validators.required]),
        'pin': new FormControl('', [Validators.required]),
        'prof': new FormControl('', [Validators.required]),
        'btf': new FormControl('', [Validators.required]),
        'dob': new FormControl('', [Validators.required]),
        'q1': new FormControl('', [Validators.required]),
        'q2': new FormControl('', [Validators.required]),
        'q3': new FormControl('', [Validators.required]),
        'q4': new FormControl('', [Validators.required]),
        'q5': new FormControl('', [Validators.required]),
        'q6': new FormControl('', [Validators.required]),
        'q7': new FormControl('', [Validators.required]),
        'q8': new FormControl('', [Validators.required]),
        'q9': new FormControl('', [Validators.required]),
        'q10': new FormControl(''),
        'q11': new FormControl('', [Validators.required]),
        'q12': new FormControl(''),
        'q13': new FormControl('', [Validators.required]),
        'q14': new FormControl('', [Validators.required]),
        'q15': new FormControl('', [Validators.required]),
        'q16': new FormControl('', [Validators.required]),
       });
      this.route.params.subscribe(params => {
        const id = +params['id'];
         this.post_id = id;
         });
         this.timer = setInterval(() => this.timedelay(), 1000)
     }

  ngOnInit() {
    this.loading = true;
    this.getAllState();
    this.getAllCity();
  }
  timedelay() {

    this.counter = this.counter  - 1;
    if (this.counter === 0) {
      const udata = this.commonService.getUserDataLocally();
      this.userid = udata.uid;
      this.adoptionform.uname = udata .uname;
      this.adoptionform.uemail = udata.uemail;
      this.adoptionform.umobile = udata.umobile;
      this.loading = false;
      clearInterval(this.timer);
      this.alreadySentRequestForAdoption();
      this.getPostDetail();
      this.getLatestAdoptionrequestFormData()
    }
  }
  getAllCity() {
    this.adoptionService.getAdoptionCity()
    .subscribe(
      (x) => {
        this.city = x;
      });
  }
  getAllState() {
    this.adoptionService.getAllState()
    .subscribe(
      (x) => {
        this.state = x;
    });
  }
  postForAdoptionRequest(form: NgForm) {
    this.loading = true;
    let q10 = 'No Detail';
    let q12 = 'No detail';
    if ( form.value.q9 === 'yes') {
      q10 = form.value.q10;
    }
    if ( form.value.q11 === 'yes') {
      q12 = form.value.q12;
    }
    this.adoptionService.SendAdoptionPostRequestForm(form.value.state, form.value.city , form.value.pin,
       form.value.prof, form.value.btf, form.value.q1, form.value.q2, form.value.q3, form.value.q4,
       form.value.q5, form.value.q6, form.value.q7, form.value.q8, form.value.q9, q10, form.value.q11,
      q12, form.value.q13 , form.value.q14, form.value.q15 , form.value.dob)
      .subscribe(
        (x) => {
          this.loading = false;
          this.createAdoptionRequest(x.id);
        });
  }
  goBack() {
    this.location.back();
  }
  createAdoptionRequest(formid) {
    this.loading = true;
    this.adoptionService.postContactRequest(formid, this.post_id, this.userid)
    .subscribe(
      (x) => {
        this.formstatus = 1;
        this.loading = false;
        this.msg = 'Request Sent';
        this.openSnackBar();
      });
  }
  openSnackBar() {
    this.snackbar.open(this.msg , this.action, {
      duration: 4000,
    });
  }
 /* uodateDob(dob) {
    this.commonService. updateUserDob(dob, this.userid)
    .subscribe(
      (x) => {
        this.msg = 'dob updated';
      });
  }*/
  alreadySentRequestForAdoption() {
    this.adoptionService.alreadySentRequestForAdoption(this.post_id, this.userid)
    .subscribe(
      (x) => {
        const adopreq = x;
        this.loading = false;
        if ( adopreq.length > 0  ) {
          this.adoprequestflag = 1;
        }else {
          this.adoprequestflag = 0;
        }
      });
  }
  getPostDetail() {
    this.adoptionService.getPostDetail(this.post_id)
    .subscribe(
     (x) => {
      if (x.user_id == this.userid) {
        this.puserflag = 1;
      }else {
        this.puserflag = 0;
      }
      });
  }
  getpreviousFormDetail() {
    this.loading = true;
    this.adoptionService.getLastAdoptionform(this.lastadoptionformid)
    .subscribe(
      (x) => {
        this.lastadoptionform = x;
        this.loading = false;
        this.adoptionform.state = this.lastadoptionform.state_id;
        this.adoptionform.city = this.lastadoptionform.city_id;
        this.adoptionform.pin = this.lastadoptionform.pin;
        this.adoptionform.prof = this.lastadoptionform.profession;
        this.adoptionform.dob = this.lastadoptionform.dob;
        this.adoptionform.btf = this.lastadoptionform.timetocall;
        this.adoptionform.q1 = this.lastadoptionform.allagree;
        this.adoptionform.q2 = this.lastadoptionform.caretaker;
        this.adoptionform.q3 = this.lastadoptionform.housetype;
        this.adoptionform.q4 = this.lastadoptionform.isrented;
        this.adoptionform.q5 = this.lastadoptionform.peoplecount;
        this.adoptionform.q6 = this.lastadoptionform.kidscount;
        this.adoptionform.q7 = this.lastadoptionform.pethome;
        this.adoptionform.q8 = this.lastadoptionform.restriction;
        this.adoptionform.q9 = this.lastadoptionform.prevpet;
        this.adoptionform.q10 = this.lastadoptionform.prevpetdetails;
        this.adoptionform.q11 = this.lastadoptionform.currentpet;
        this.adoptionform.q12 = this.lastadoptionform.currentpetdetails;
        this.adoptionform.q13 = this.lastadoptionform.availtime;
        this.adoptionform.q14 = this.lastadoptionform.expenses;
        this.adoptionform.q15 = this.lastadoptionform.housecheck;
      });
  }
  getLatestAdoptionrequestFormData() {
    this.adoptionService.getAdoptionFormForUser(this.userid)
    .subscribe(
      (x) => {
        this.lastadoptionformid = x[0].adoptionform_id;
      });
  }
}
